import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import MailTileSkeleton from "./MailTileSkeleton";

const SKELETON_TILES_COUNT = 12;

type EmailMosaicSkeletonProps = {
    columns?: number;
};

const EmailMosaicSkeleton = ({ columns }: EmailMosaicSkeletonProps) => {
    const { t } = useTranslation();

    const [screenWidth, setScreenWidth] = useState<number>(() =>
        typeof window !== "undefined" ? window.innerWidth : 0,
    );

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const gridColumns = useMemo(() => {
        if (columns) {
            return columns;
        }

        if (screenWidth < 768) {
            return 2;
        }

        if (screenWidth < 1280) {
            return 3;
        }

        return 4;
    }, [columns, screenWidth]);

    return (
        <div
            aria-busy="true"
            aria-label={t("emails.loading")}
            className="mb-4 grid w-full gap-3"
            style={{
                gridTemplateColumns: `repeat(${gridColumns}, minmax(0, 1fr))`,
            }}
        >
            {Array.from({ length: SKELETON_TILES_COUNT }, (_, index) => (
                <MailTileSkeleton key={index} />
            ))}
        </div>
    );
};

export default EmailMosaicSkeleton;
